<script>
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [children]
     */
    let { children } = $props();
</script>

<section class="section">
    {@render children?.()}
</section>

<style>
    .section {
        left: 0;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        width: calc(100vw - (100vw - 100%));
        height: 100%;
    }
</style>
